/* eslint-disable @nx/workspace/no-restricted-imports-clone */
import React from 'react';

import {
  CloseButtonProps,
  forwardRef,
  ModalCloseButton as ChakraModalCloseButton,
} from '@chakra-ui/react';

import { CloseIcon } from '../../icons';

export const ModalCloseButton = forwardRef<CloseButtonProps, 'button'>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraModalCloseButton ref={ref} {...props}>
        {children || <CloseIcon />}
      </ChakraModalCloseButton>
    );
  }
);
